export default "__VITE_ASSET__b0ae4592__"